// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_environment_model from "./web_environment_model.js";
import * as Mapre_web__Web_file_input from "./web_file_input.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Int from "melange/int.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function disabled(p) {
  if (p.loading) {
    return true;
  } else {
    return p.pending;
  }
}

function field(source, send, get, label, change) {
  const partial_arg = label;
  const partial_arg$1 = "muted";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___001_) {
        const partial_arg = (function (param) {
          return Lui_elements.on_input(send, (function (value) {
            return {
              TAG: /* Environment */ 33,
              _0: {
                TAG: /* Change */ 3,
                _0: change,
                _1: value
              }
            };
          }), param);
        });
        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map(disabled, source)));
        const partial_arg$2 = label;
        const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map(get, source)));
        return function (param, param$1) {
          return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$3 = 0;
  const partial_arg$4 = 6;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
}

function multiline(source, send, get, label, change) {
  const partial_arg = label;
  const partial_arg$1 = "muted";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___002_) {
        const partial_arg = (function (param) {
          return Lui_elements.on_input(send, (function (value) {
            return {
              TAG: /* Environment */ 33,
              _0: {
                TAG: /* Change */ 3,
                _0: change,
                _1: value
              }
            };
          }), param);
        });
        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map(disabled, source)));
        const partial_arg$2 = label;
        const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map(get, source)));
        const partial_arg$4 = 120;
        return function (param, param$1) {
          return Lui_elements.textarea(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$3 = 0;
  const partial_arg$4 = 6;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
}

function choices(source, send) {
  const partial_arg = Stdlib__List.map((function (param) {
    const kind = param[1];
    const label = param[0];
    return function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___003_) {
        const partial_arg = {
          TAG: /* Environment */ 33,
          _0: {
            TAG: /* Choose */ 2,
            _0: kind
          }
        };
        const partial_arg$1 = (function (param) {
          return Lui_elements.press(send, partial_arg, param);
        });
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map(disabled, source)));
        const partial_arg$3 = "outline";
        const partial_arg$4 = label;
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    };
  }), {
    hd: [
      "Native environment",
      /* Native */ 0
    ],
    tl: {
      hd: [
        "Repository Dockerfile",
        /* Repository */ 1
      ],
      tl: {
        hd: [
          "Uploaded Dockerfile",
          /* Uploaded */ 2
        ],
        tl: /* [] */ 0
      }
    }
  });
  const partial_arg$1 = "wrap";
  const partial_arg$2 = 8;
  return function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, param, param$1);
  };
}

function uploaded(source, send) {
  const partial_arg = "Upload Dockerfile";
  const partial_arg$1 = "muted";
  const partial_arg$2 = Signal.map(disabled, source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Mapre_web__Web_file_input.view(partial_arg$2, (function (name, content) {
        Curry._1(send, {
          TAG: /* Environment */ 33,
          _0: {
            TAG: /* Upload */ 5,
            _0: name,
            _1: content
          }
        });
      }), (function (message) {
        Curry._1(send, {
          TAG: /* Environment */ 33,
          _0: {
            TAG: /* Failed */ 7,
            _0: message
          }
        });
      }), param, param$1);
    }),
    tl: {
      hd: field(source, send, (function (p) {
        return p.draft.filename;
      }), "Dockerfile filename", /* Filename */ 1),
      tl: {
        hd: multiline(source, send, (function (p) {
          return p.draft.content;
        }), "Dockerfile content", /* Content */ 2),
        tl: /* [] */ 0
      }
    }
  };
  const partial_arg$3 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$4 = 0;
  const partial_arg$5 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, param, param$1);
  };
}

function docker_fields(source, send) {
  const partial_arg = field(source, send, (function (p) {
    return p.draft.path;
  }), "Dockerfile path", /* Path */ 0);
  const partial_arg$1 = Signal.map((function (p) {
    return p.draft.source === /* Repository */ 1;
  }), source);
  const partial_arg$2 = uploaded(source, send);
  const partial_arg$3 = Signal.map((function (p) {
    return p.draft.source === /* Uploaded */ 2;
  }), source);
  const partial_arg$4 = "Directory in the pinned repository used for COPY and ADD. Use . for the repository root.";
  const partial_arg$5 = "muted";
  const partial_arg$6 = "Leave the target empty for the final stage. Build arguments are saved in version history. Do not put credentials in build arguments.";
  const partial_arg$7 = "muted";
  const partial_arg$8 = "Check the Dockerfile path, build context, target and build arguments.";
  const partial_arg$9 = "notice";
  const partial_arg$10 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$11 = Signal.map((function (p) {
    return Mapre_web__Web_environment_model.configuration(p.draft) === undefined;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$3, partial_arg$2, param, param$1);
    }),
    tl: {
      hd: field(source, send, (function (p) {
        return p.draft.context;
      }), "Build context directory", /* Context */ 3),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: {
          hd: field(source, send, (function (p) {
            return p.draft.target;
          }), "Build target", /* Target */ 4),
          tl: {
            hd: multiline(source, send, (function (p) {
              return p.draft.arguments;
            }), "Build arguments (JSON)", /* Arguments */ 5),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              }),
              tl: {
                hd: (function (param, param$1) {
                  return Lui_elements.if_(partial_arg$11, partial_arg$10, param, param$1);
                }),
                tl: /* [] */ 0
              }
            }
          }
        }
      }
    }
  };
  const partial_arg$12 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$13 = 0;
  const partial_arg$14 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, param, param$1);
  };
}

function conflict(source, send) {
  const partial_arg = "Environment changed. Your draft is preserved. Reload the current version before saving.";
  const partial_arg$1 = "notice";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___004_) {
        const partial_arg = {
          TAG: /* Environment */ 33,
          _0: /* Reload */ 1
        };
        const partial_arg$1 = (function (param) {
          return Lui_elements.press(send, partial_arg, param);
        });
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map(disabled, source)));
        const partial_arg$3 = "outline";
        const partial_arg$4 = "Reload current environment";
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$3 = 8;
  const partial_arg$4 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
  const partial_arg$5 = Signal.map((function (p) {
    return p.conflict;
  }), source);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
  };
}

function history(source, send) {
  const partial_arg = Signal.map((function (p) {
    return p.history;
  }), source);
  const partial_arg$1 = Signal.map((function (p) {
    return p.next_version !== undefined;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.keyed(partial_arg, (function (r) {
      return r.version;
    }), Stdlib__Int.compare, (function (param) {
      const revision = Signal.sample(param);
      const partial_arg_0 = function (param$1, param$2) {
        return Lui_elements.scoped((function (__lui_context___005_) {
          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (r) {
            return "Version " + (String(r.version) + (" \xc2\xb7 " + Stdlib__Option.value(r.actor, "Initial configuration")));
          }), param)));
          const partial_arg$1 = "muted";
          return function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param$1, param$2);
      };
      const partial_arg_1 = {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___006_) {
            const partial_arg = {
              TAG: /* Environment */ 33,
              _0: {
                TAG: /* Use_revision */ 9,
                _0: revision
              }
            };
            const partial_arg$1 = (function (param) {
              return Lui_elements.press(send, partial_arg, param);
            });
            const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map(disabled, source)));
            const partial_arg$3 = "ghost";
            const partial_arg$4 = "Use version " + (String(revision.version) + " as draft");
            return function (param, param$1) {
              return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }),
        tl: /* [] */ 0
      };
      const partial_arg = {
        hd: partial_arg_0,
        tl: partial_arg_1
      };
      const partial_arg$1 = "environment-version";
      const partial_arg$2 = 12;
      const partial_arg$3 = 4;
      return function (param, param$1) {
        return Lui_elements.column(undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$1, (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___008_) {
          const partial_arg = {
            TAG: /* Environment */ 33,
            _0: /* More_history */ 6
          };
          const partial_arg$1 = (function (param) {
            return Lui_elements.press(send, partial_arg, param);
          });
          const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (p) {
            if (p.history_loading) {
              return true;
            } else {
              return disabled(p);
            }
          }), source)));
          const partial_arg$3 = "ghost";
          const partial_arg$4 = "More environment versions";
          return function (param, param$1) {
            return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$3 = 8;
  const partial_arg$4 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
  const partial_arg$5 = Signal.map((function (p) {
    return p.history_open;
  }), source);
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___007_) {
      const partial_arg = {
        TAG: /* Environment */ 33,
        _0: /* History */ 5
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (p) {
        if (disabled(p)) {
          return true;
        } else {
          return p.history_loading;
        }
      }), source)));
      const partial_arg$3 = "ghost";
      const partial_arg$4 = "Version history";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$6 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$7 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, param, param$1);
  };
}

function controls(source, send) {
  const partial_arg = {
    TAG: /* Environment */ 33,
    _0: /* Close */ 0
  };
  const partial_arg$1 = (function (param) {
    return Lui_elements.press(send, partial_arg, param);
  });
  const partial_arg$2 = "ghost";
  const partial_arg$3 = "Close environment";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___009_) {
      const partial_arg = {
        TAG: /* Environment */ 33,
        _0: /* Save */ 2
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map((function (p) {
        return !Mapre_web__Web_environment_model.can_save(p);
      }), source)));
      const partial_arg$3 = "primary";
      const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map((function (p) {
        if (p.pending) {
          return "Saving...";
        } else {
          return "Save environment";
        }
      }), source)));
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$4 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$5 = "wrap";
  const partial_arg$6 = 8;
  return function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, partial_arg$4, param, param$1);
  };
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return Stdlib__Option.value(m.environment_form, Mapre_web__Web_environment_model.initial(""));
  }), model);
  const partial_arg = "Environment";
  const partial_arg$1 = 2;
  const partial_arg$2 = "All workspace members can edit this configuration. Saving does not start a build or change existing sessions.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = docker_fields(source, send);
  const partial_arg$5 = Signal.map((function (p) {
    return p.draft.source !== /* Native */ 0;
  }), source);
  const partial_arg$6 = Signal.map((function (p) {
    return p.message !== "";
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___010_) {
          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___010_.ui_scope, Signal.map((function (p) {
            return Stdlib__Option.fold("Loading environment...", (function (version) {
              return "Environment version " + String(version);
            }), p.version);
          }), source)));
          const partial_arg$1 = "eyebrow";
          return function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }),
      tl: {
        hd: choices(source, send),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$6, (function (param, param$1) {
                return Lui_elements.scoped((function (__lui_context___011_) {
                  const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___011_.ui_scope, Signal.map((function (p) {
                    return p.message;
                  }), source)));
                  const partial_arg$1 = "notice";
                  return function (param, param$1) {
                    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param, param$1);
              }), param, param$1);
            }),
            tl: {
              hd: conflict(source, send),
              tl: {
                hd: controls(source, send),
                tl: {
                  hd: history(source, send),
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    }
  };
  const partial_arg$7 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$8 = "form-card";
  const partial_arg$9 = 0;
  const partial_arg$10 = 16;
  const partial_arg$11 = 16;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
